import { CTACard, CTAContainer, Notification, Section } from "@in/component-library";
import React, { FC } from "react";
import { sendSiteimproveEvent } from "../../../utils/sendSiteimproveEvent";
import { ApiException } from "../../apis/api-error";
import { HighlightedLinkResponse } from "../../models/highlighted-link-response";

interface HightlightedLinkListProps {
  heading: string;
  links?: HighlightedLinkResponse[];
  error?: ApiException;
  errorMessage?: string;
}

const HighlightedLinkList: FC<HightlightedLinkListProps> = ({ heading, links, error, errorMessage }) => {
  const handleOnclick = (linkTitle: string) => {
    sendSiteimproveEvent("Highlighted links", "GoToLink", linkTitle);
  };

  return (
    <Section collapse className="highlighted-category">
      {links && links.length > 0 ? (
        <>
          <h2 dangerouslySetInnerHTML={{ __html: heading }} />
          <CTAContainer columns={3}>
            {links.map((highlightedLink) => (
              <CTACard
                key={highlightedLink.url}
                header={highlightedLink.title}
                onClick={() => handleOnclick(highlightedLink.title)}
                href={highlightedLink.url}
                text={highlightedLink.description}
              />
            ))}
          </CTAContainer>
        </>
      ) : (
        error && (
          <>
            <h2 dangerouslySetInnerHTML={{ __html: heading }} />
            <Notification fullWidth type="error">
              {errorMessage}
            </Notification>
          </>
        )
      )}
    </Section>
  );
};

export default HighlightedLinkList;
